import { PrimaryButton } from "components/Button/style";
import { MaisFiltros } from "components/ButtonModal";
import { CustomInputModal } from "components/CustomInputModal";
import { DropdownSelect } from "components/DropdownSelect";
import { useEmpresas } from "hooks/useEmpresas";
import { ReactNode, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm, useWatch } from "react-hook-form";
import { FILTROS_ITENS_LOTE_VAZIOS } from "../../../../constants/filtrosItensLote";
import { OPCOES_PRENSA } from "../../../../constants/opcoesSolicitarAutorizacao";
import {
  opcoesStatusAutorizacaoItem,
  opcoesStatusProducaoItem,
} from "../../../../constants/status";
import {
  BotoesContainer,
  CampoMaisFiltros,
  Container,
  MaisFiltrosContainer,
  MaisFiltrosDropdownWrapper,
  Title,
} from "../../../../containers/Filtros/style";
import { IFiltrosItensLote } from "../../../../interfaces/IFiltrosItensLote";
import { codigoOuNulo } from "../../../../utils/codigoOuNulo";
import { HeaderLote } from "./style";

type CampoCodigo =
  | "prensa"
  | "statusAutorizacao"
  | "statusProducao"
  | "idEmpresa";

interface IProps {
  titulo: string;
  acoes: ReactNode;
  onBuscar: (filtros: IFiltrosItensLote) => void;
}

export function Filtros({ titulo, acoes, onBuscar }: IProps) {
  const { control, handleSubmit, reset, setValue } = useForm<IFiltrosItensLote>(
    { defaultValues: FILTROS_ITENS_LOTE_VAZIOS }
  );
  const prensa = useWatch({ control, name: "prensa" });
  const statusAutorizacao = useWatch({ control, name: "statusAutorizacao" });
  const statusProducao = useWatch({ control, name: "statusProducao" });
  const idEmpresa = useWatch({ control, name: "idEmpresa" });
  const { empresasOptions } = useEmpresas();

  // Estáveis: o DropdownSelect chama onSelect num efeito que depende dele.
  const selecionar = useMemo(() => {
    const em = (campo: CampoCodigo) => (valor: string | number | null) =>
      setValue(campo, codigoOuNulo(valor));

    return {
      prensa: em("prensa"),
      statusAutorizacao: em("statusAutorizacao"),
      statusProducao: em("statusProducao"),
      idEmpresa: em("idEmpresa"),
    };
  }, [setValue]);

  function handleLimparMaisFiltros() {
    setValue("idEmpresa", null);
    setValue("idProcesso", []);
  }

  function handleLimpar() {
    reset(FILTROS_ITENS_LOTE_VAZIOS);
    onBuscar(FILTROS_ITENS_LOTE_VAZIOS);
  }

  return (
    <Container>
      <HeaderLote>
        <Title>{titulo}</Title>
        {acoes}
      </HeaderLote>
      <hr />
      <Form noValidate onSubmit={handleSubmit((filtros) => onBuscar(filtros))}>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Placa</Form.Label>
              <Controller
                control={control}
                name="placa"
                render={({ field: { value, onChange } }) => (
                  <CustomInputModal
                    label="Filtrar em massa"
                    value={value}
                    placeholder="Busque por placa"
                    onConfirm={onChange}
                    validar={false}
                    style={{ width: "100%" }}
                    placeholderModal="Digite ou cole as placas e tecle ENTER"
                    labelItem="Placa"
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Prensa</Form.Label>
              <DropdownSelect
                options={OPCOES_PRENSA}
                selectedValue={prensa}
                onSelect={selecionar.prensa}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Status autorização</Form.Label>
              <DropdownSelect
                options={opcoesStatusAutorizacaoItem}
                selectedValue={statusAutorizacao}
                onSelect={selecionar.statusAutorizacao}
                permitirZero
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Status produção</Form.Label>
              <DropdownSelect
                options={opcoesStatusProducaoItem}
                selectedValue={statusProducao}
                onSelect={selecionar.statusProducao}
                permitirZero
              />
            </Form.Group>
          </Col>
          <Col md="auto">
            <BotoesContainer>
              <PrimaryButton
                type="button"
                outline
                variante="primary"
                onClick={handleLimpar}
              >
                Limpar
              </PrimaryButton>
              <PrimaryButton type="submit">Buscar</PrimaryButton>
            </BotoesContainer>
          </Col>
          <Col style={{ paddingTop: "5px" }}>
            <MaisFiltrosContainer>
              <Form.Group>
                <MaisFiltrosDropdownWrapper>
                  <MaisFiltros
                    limparTudoOnClick={handleLimparMaisFiltros}
                    cancelarOnClick={handleLimparMaisFiltros}
                    handleClickAplicarFiltros={() => {}}
                    widthModal="lg"
                    submit
                  >
                    <CampoMaisFiltros>
                      <Form.Group>
                        <Form.Label>Empresa</Form.Label>
                        <DropdownSelect
                          options={empresasOptions}
                          selectedValue={idEmpresa}
                          onSelect={selecionar.idEmpresa}
                          searchable
                        />
                      </Form.Group>
                    </CampoMaisFiltros>

                    <CampoMaisFiltros>
                      <Form.Group>
                        <Form.Label>ID Processo</Form.Label>
                        <Controller
                          control={control}
                          name="idProcesso"
                          render={({ field: { value, onChange } }) => (
                            <CustomInputModal
                              label="Filtrar em massa"
                              value={value}
                              placeholder="Busque por ID"
                              onConfirm={onChange}
                              validar={false}
                              style={{ width: "100%" }}
                              placeholderModal="Digite ou cole os IDs dos processos e tecle ENTER"
                              labelItem="ID Processo"
                            />
                          )}
                        />
                      </Form.Group>
                    </CampoMaisFiltros>
                  </MaisFiltros>
                </MaisFiltrosDropdownWrapper>
              </Form.Group>
            </MaisFiltrosContainer>
          </Col>
        </Row>
      </Form>
    </Container>
  );
}
